
import { defineComponent, ref, computed, onMounted } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import type { ElForm } from "element-plus";
import { ElMessage } from "element-plus";
import { Compound } from "@/store/modules/CompoundModule"
import NewBoxItemInfoModal from "@/components/modals/forms/NewBoxItemInfoModal.vue"
import ApiService from "@/core/services/ApiService"

type FormInstance = InstanceType<typeof ElForm>;

export default defineComponent({
  components: {
    NewBoxItemInfoModal
  },
  setup() {
    onMounted(() => {
      if (!route.params.id) {
        setCurrentPageBreadcrumbs("合成新增", ["合成管理;compounds"])
      } else {
        setCurrentPageBreadcrumbs("合成编辑", ["合成管理;compounds", route.params.id.toString()])
      }
    });

    const rules = ref({
      // name: [
      //   {
      //     required: true,
      //     message: "商圈名称不可为空",
      //     trigger: "change",
      //   },
      // ],
    });

    const formRef = ref<FormInstance>();
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const compound = ref({
      id: 0,
      product_name: '请选择商品',
      product_id: 0,
      price: 0,
      sorting: 0,
      enabled: false,
      compound_qty: 0,
      stock: 0,
      water_need: 0,
      daily_limit: 0,
      compound_type: (route.query.compound_type as string) || 'product',
      compound_category_id: null,
      compound_category_name: null,
      excluded_product_ids: [] as number[],
      excluded_products: [] as { id: number; name: string; recycle_price: number }[],
    } as unknown as Compound)

    const excludedProductOptions = ref([] as any[])
    const excludedProductLoading = ref(false)

    const searchExcludedProducts = async (query: string) => {
      if (!query) return
      excludedProductLoading.value = true
      try {
        ApiService.setHeader()
        const { data } = await ApiService.get(`admin/products?name=${encodeURIComponent(query)}&pageSize=200`)
        excludedProductOptions.value = data.products || []
      } catch {
        // ignore
      } finally {
        excludedProductLoading.value = false
      }
    }

    const allCategories = ref([] as any[])

    // 加载所有分类
    store
      .dispatch(Actions.GET_COMPOUND_CATEGORIES, { pageSize: 999, currentPage: 1 })
      .then(() => {
        allCategories.value = store.getters.currentCompoundCategories
      })
      .catch((_e) => undefined)

    const filteredCategories = computed(() => {
      const type = compound.value.compound_type
      if (!type) return allCategories.value
      // compound_type: 'product' | 'card'（后端 enum 返回字符串）
      return allCategories.value.filter((c) => c.compound_type === type)
    })

    const onCancel = () => {
      router.push({ name: "compounds", query: { compound_type: compound.value.compound_type } });
    };

    const isNew = !route.params.id;

    const onSubmit = (formEl: FormInstance | undefined) => {
      if (!formEl) return;

      formEl.validate((valid) => {
        if (valid) {
          if (isNew) {
            store
              .dispatch(
                Actions.CREATE_COMPOUND,
                compound.value
              )
              .then((data) => {
                if (data.success) {
                  ElMessage.success('新增成功')
                  router.push({ name: "compounds", query: { compound_type: compound.value.compound_type } });
                } else {
                  ElMessage.error(data.error_msg || '新增失败')
                }
              })
              .catch(() => {
                ElMessage.error('新增失败')
              });
          } else {
            store
              .dispatch(Actions.UPDATE_COMPOUND, {
                id: route.params.id,
                values: compound.value,
              })
              .then((data) => {
                if (data.success) {
                  ElMessage.success('更新成功')
                  router.push({ name: "compounds", query: { compound_type: compound.value.compound_type } });
                } else {
                  ElMessage.error(data.error_msg || '更新失败')
                }
              })
              .catch(() => {
                ElMessage.error('更新失败')
              });
          }
        } else {
          return false;
        }
      });
    };

    if (!isNew) {
      store
        .dispatch(Actions.GET_COMPOUND, route.params.id)
        .then(() => {
          compound.value = store.getters.currentCompound
          // 预填排除素材选项，避免 edit 时 tag 只显示 id
          if (compound.value.excluded_products?.length > 0) {
            excludedProductOptions.value = compound.value.excluded_products
          }
        })
        .catch(() => {
          // const [error] = Object.keys(store.getters.getErrors);
          // Swal.fire({
          //   text: store.getters.getErrors[error],
          //   icon: "error",
          //   buttonsStyling: false,
          //   confirmButtonText: "Try again!",
          //   customClass: {
          //     confirmButton: "btn fw-bold btn-light-danger",
          //   },
          // });
        });
    }

    const add_box_item_infos = (products) => {
      console.log(i)

      if (products[0]) {
        var i = products[0]
        console.log(i)
        compound.value.product_id = i.id
        compound.value.product_name = i.brand + "_" + i.ip + "_" + i.name
        compound.value.price = i.recycle_price
      }
    }

    return {
      onSubmit,
      compound,
      rules,
      onCancel,
      formRef,
      add_box_item_infos,
      isNew,
      filteredCategories,
      excludedProductOptions,
      excludedProductLoading,
      searchExcludedProducts,
    };
  },
});
